import { useMutation, useQuery } from "@tanstack/react-query";
import { useAlert } from "context/alert";
import { useState } from "react";
import { useSelector } from "react-redux";
import { createKYCDocumentUpload } from "services/kyc";
import { createPatientDocumentUpload } from "services/resultEntryReportMaster";
import zoneLocalStorageId from "utils/zone";

const UploadDocument = ({
  onClose,
  rowData,
  setdocumentInfo,
  setDocumentModal,
  setIsOpenObservationValue,
  setIsKycModalOpen,
}) => {
  const { showAlert } = useAlert();
  const [files, setFiles] = useState([]);
  const [fileRequired, setFileRequired] = useState(false);
  const [documentType, setDocumentType] = useState("");
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const _token =
    jwtAuthreducer?.token_values?.sub &&
    JSON.parse(jwtAuthreducer?.token_values?.sub?.replace(/'/g, '"'));

  const [filePath, setFilePath] = useState("");

  const handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);

    // Check if adding new files would exceed the limit of 3
    if (files.length + selectedFiles.length > 3) {
      showAlert("Maximum 3 files can be uploaded", "warning");
      return;
    }

    // Process each selected file
    const processedFiles = await Promise.all(
      selectedFiles.map(async (file) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            const base64String = reader.result;
            const base64Data = base64String.split(",")[1];

            resolve({
              file: file,
              fileName: file.name,
              fileData: base64Data,
            });
          };
          reader.onerror = (error) => {
            console.error("Error converting file to base64:", error);
            resolve(null);
          };
        });
      })
    );

    setFiles([...files, ...processedFiles.filter((file) => file !== null)]);
    setFilePath(
      files.length > 0 ? "multiple_files" : selectedFiles[0]?.name || ""
    );
    setFileRequired(files.length + selectedFiles.length === 0);
  };

  const removeFile = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
    setFileRequired(updatedFiles.length === 0);
  };

  const onSuccess = (res) => {
    showAlert("Documents uploaded successfully!");
    onClose();
  };

  const onError = (res) => {
    console.log(res);
    showAlert("Error uploading documents", "error");
  };

  const { mutate: addDocumentMutate } = useMutation({
    mutationFn: createKYCDocumentUpload,
    onSuccess,
    onError,
  });

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (files.length === 0) {
  //     setFileRequired(true);
  //     return;
  //   }

  //   const fileDataArray = files.map((fileObj) => ({
  //     file_name: fileObj.fileName,
  //     file_data: fileObj.fileData,
  //   }));

  //   const payload = {
  //     patient_id: rowData?.patient_id,
  //     appointment_id: rowData?.appointment_id,
  //     investigation_id: rowData?.investigation_data?.investigation_id,
  //     file_data: fileDataArray,
  //     file_path: filePath || "multiple_files",
  //     franchise_id: rowData?.franchise_id || _token?.franchise_id,
  //     zone_id: rowData?.zone_id || Number(zoneLocalStorageId),
  //     is_active: true,
  //     created_by: jwtAuthreducer.user.employee_code_id,
  //   };

  //   console.log("payload", payload);

  //   if (payload) {
  //     addDocumentMutate(payload);
  //   }
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (files.length === 0) {
      setFileRequired(true);
      return;
    }

    const fileObj = files[0];

    const payload = {
      document_name: documentType,
      file_name: fileObj.fileName,
      file_data: fileObj.fileData,
      file_path: filePath || "single_file",
      franchise_id: rowData?.franchise_id || _token?.franchise_id,
      zone_id: rowData?.zone_id || zoneLocalStorageId(),
      is_active: true,
      created_by: jwtAuthreducer.user.employee_code_id,
    };

    addDocumentMutate(payload);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mt-3">
        <label className="form-label">
          Document Type <span className="alertColor">*</span>
        </label>
        <select
          className="form-select"
          value={documentType}
          onChange={(e) => setDocumentType(e.target.value)}
          required
        >
          <option value="">Select Document Type</option>
          <option value="Aadhaar Card">Aadhaar Card</option>
          <option value="PAN Card">PAN Card</option>
          <option value="Voter ID">Voter ID</option>
        </select>
      </div>

      <div className="mt-3">
        <label className="form-label">
          Upload Document <span className="alertColor">*</span>
          {files.length > 0 && (
            <span className="ms-2 text-muted">({files.length}/3 files)</span>
          )}
        </label>
        <input
          type="file"
          className={`form-control ${fileRequired ? "is-invalid" : ""}`}
          onChange={handleFileChange}
          accept=".pdf,image/*"
          multiple
          disabled={files.length >= 3}
        />
        {fileRequired && <div className="text-danger">File is required</div>}
        {files.length >= 3 && (
          <div className="text-warning mt-1">
            Maximum file limit reached (3)
          </div>
        )}
      </div>

      {files.length > 0 && (
        <div className="mt-3">
          <label className="form-label">Selected Files:</label>
          <ul className="list-group">
            {files.map((fileObj, index) => (
              <li
                key={index}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                <div className="text-truncate" style={{ maxWidth: "80%" }}>
                  {fileObj.fileName}
                </div>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => removeFile(index)}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="mt-4 d-flex justify-content-start">
        <button type="submit" className="btn btn-primary">
          Upload
        </button>
      </div>
    </form>
  );
};

export default UploadDocument;
